import axios from 'axios';
import router from '../router/index';
import $ from 'jquery';
import Vue from 'vue';
import { Message } from 'element-ui';
const eventprogram = {
    state: () => ({
        items: [],
        saloons: [],
        days: [],
        speakers: [],
        subEvents: [],
        pendingProgramRateCount: 0,
        rateFilter: {
            skip: 0,
            take: 20,
            page: 1,
            total: 0,
            searchTerm: null,
            ids: [],
            participantNo: null,
            programId: null,
            userId: null,
            participantId: null,
            minRate: null,
            maxRate: null,
            status: null,
            includeUsers: false,
        },
        rateList: [],
        filter: {
            dayId: null,
            saloonId: null,
            subEventId: null,
            speakerId: null,
            searchTerm: null,
        },
    }),
    mutations: {
        setEventProgram(state, payload) {
            state.items = [];
            payload.items.map((x) => {
                state.items.push({...x, show: false });
            });
            state.saloons = payload.saloons;
            state.days = payload.days;
            state.speakers = payload.speakers;
            state.subEvents = payload.subEvents;
            state.pendingProgramRateCount = payload.pendingProgramRateCount;
        },
        eventFilterDayId(state, payload) {
            state.filter.dayId = payload;
        },
        setEventProgramRate(state,payload){
            state.rateList = payload.items;
            state.rateFilter.total = payload.totalCount;
        }
    },
    actions: {
        async changeEventProgramRateStatus(store,payload){
            var res = await axios.post('EventProgram/ChangeStatusRate', payload);
            if (res.data.alert.hasError) {
                Message.error(res.data.alert.message);
            } else {
                Message.success(res.data.alert.message);
                await store.dispatch('getEventProgramRate');
            }
        },
        async deleteEventProgramRate(store,payload){
            var res = await axios.post('EventProgram/DeleteRate', {id : payload});
            if (res.data.alert.hasError) {
                Message.error(res.data.alert.message);
            } else {
                Message.success(res.data.alert.message);
                await store.dispatch('getEventProgramRate');
            }
        },
        async getEventProgramRate(store) {
            var res = await axios.post('EventProgram/ListRates',{...store.state.rateFilter, skip: (store.state.rateFilter.page - 1) * store.state.rateFilter.take } );
            if(res.data.alert.hasError){
                Message.error(res.data.alert.message);
            }else {
                store.commit('setEventProgramRate', res.data.data);
            }
            return res;
        },
        async getEventProgram(store) {
            var res = await axios.post('EventProgram/List', {});
            store.commit('setEventProgram', res.data.data);
        },
        async getEvenProgramOne(store, payload) {
            var res = await axios.post('EventProgram/Get', { id: payload });
            return res.data.data.item;
        },
        async addUpdateProgram(store, payload) {
            var res = await axios.post('EventProgram/ProgramAddOrUpdate', payload);
            if (res.data.alert.hasError) {
                Message.error(res.data.alert.message);
            } else {
                Message.success(res.data.alert.message);
                if (payload.id == null) {
                    store.state.items.push(res.data.data.item);
                } else {
                    var cIndex = store.state.items.findIndex((x) => x.id == payload.id);
                    store.state.items.splice(cIndex, 1, res.data.data.item);
                }
            }
            return res;
        },
        async deleteEventProgram(store, payload) {
            var res = await axios.post('/EventProgram/Delete', { id: payload });
            if (res.data.alert.hasError) {
                Message.error(res.data.alert.message);
            } else {
                Message.success(res.data.alert.message);
            }
            return res;
        },
        async togglerProgram(store, payload) {
            var res = await axios.post('/EventProgram/ToggleISActive', {
                id: payload,
            });
            if (res.data.alert.hasError) {
                Message.error(res.data.alert.message);
            } else {
                Message.success(res.data.alert.message);
            }
            return res.data;
        },
        async addUpdateDay(store, payload) {
            var res = await axios.post('EventProgram/DayAddOrUpdate', payload);
            if (res.data.alert.hasError) {
                Message.error(res.data.alert.message);
            } else {
                Message.success(res.data.alert.message);
                if (payload.id == null) {
                    store.state.days.push(res.data.data.item);
                } else {
                    var cIndex = store.state.days.findIndex((x) => x.id == payload.id);
                    store.state.days.splice(cIndex, 1, res.data.data.item);
                }
            }
            return res;
        },
        async orderDays(store, payload) {
            var res = await axios.post('eventprogram/DayUpdateOrderNos', { ids: payload });
            if (res.data.alert.hasError) {
                Message.error(res.data.alert.message);
            } else {
                Message.success(res.data.alert.message);
            }
        },
        async deleteEventDay(store, payload) {
            var res = await axios.post('eventprogram/daydelete', { id: payload });
            if (res.data.alert.hasError) {
                Message.error(res.data.alert.message);
            } else {
                Message.success(res.data.alert.message);
                store.state.days = store.state.days.filter((x) => x.id != payload);
                store.state.items = store.state.items.filter((x) => x.dayID != payload);
            }
        },
        async addUpdateSaloon(store, payload) {
            var res = await axios.post('EventProgram/SaloonAddOrUpdate', payload);
            if (res.data.alert.hasError) {
                Message.error(res.data.alert.message);
            } else {
                Message.success(res.data.alert.message);
                if (payload.id == null) {
                    store.state.saloons.push(res.data.data.item);
                } else {
                    var cIndex = store.state.saloons.findIndex((x) => x.id == payload.id);
                    store.state.saloons.splice(cIndex, 1, res.data.data.item);
                }
            }
            return res;
        },
        async orderSaloons(store, payload) {
            var res = await axios.post('eventprogram/saloonUpdateOrderNos', { ids: payload });
            if (res.data.alert.hasError) {
                Message.error(res.data.alert.message);
            } else {
                Message.success(res.data.alert.message);
            }
        },
        async deleteEventSaloon(store, payload) {
            var res = await axios.post('eventprogram/saloondelete', { id: payload });
            if (res.data.alert.hasError) {
                Message.error(res.data.alert.message);
            } else {
                Message.success(res.data.alert.message);
                store.state.saloons = store.state.saloons.filter((x) => x.id != payload);
                store.state.items = store.state.items.filter((x) => x.saloonID != payload);
            }
        },
        async saveProgramOrders(context, payload) {
            var res = await axios.post('/eventprogram/ProgramUpdateOrderNos', payload);
            if (res.data.alert.hasError) {
                Message.error(res.data.alert.message);
            } else {
                Message.success(res.data.alert.message);
            }
        },
    },
    getters: {
        getEventRateList: (state) => state.rateList,
        getEventRateFilter: (state) => state.rateFilter
    },
};
export default eventprogram;


// WEBPACK FOOTER //
// ./src/store/eventprogram.js